import {Injectable, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs/internal/Subject';
import {AjaxDownloadQueueItem} from '@components/ajax-download-noty/ajax-download.service';

@Injectable()
export class JournalDownloadButtonService implements OnDestroy {
    cancel$ = new Subject();

    public allDownloadQueue$: AjaxDownloadQueueItem;
    public formDownloadQueue$: AjaxDownloadQueueItem;

    ngOnDestroy(): void {
        this.cancel$.complete();
        if (this.allDownloadQueue$) {
            this.allDownloadQueue$.complete();
        }

        if (this.formDownloadQueue$) {
            this.formDownloadQueue$.complete();
        }
    }
}
